import React, {Component, ReactElement, ReactNode} from 'react'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {Box, Table, TableBody, TableCell, TableRow} from '@mui/material'
import {PageFooterArea, PageFotterAreaLeft, PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import {
    APPLY_STATUS,
    HAVE_OR_NOT,
    MESSAGE_TYPE,
    RESIDENT_USER_REGISTRATION_APPLY_CATEGORY,
    ROLE_FOR_ADMINISTRATOR,
} from '../../../CodeMaster'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {getStringOrEmptyString, judgeAuthorityCheck} from '../../common/util/Natutil'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import {HKConstants} from '../../../HKConstants'
import {Messages} from '../../../Messages'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {NatAdminCommonDialogComponent} from '../common/admin/NatAdminCommonDialogComponent'
import {
    NatGetResidentAuthKeyNoticeApplyResponse,
    ResidentUserAuthKeyNoticeApplyInfo,
} from '../roomToResident/repository/NatGetResidentAuthKeyNoticeApply'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {
    NatPutRoomToResidentNoticeApplyPermit,
    NatPutRoomToResidentNoticeApplyPermitParams,
} from '../roomToResident/repository/NatPutRoomToResidentNoticeApplyPermit'
import {NatGetCondominium} from '../condominium/repository/NatGetCondominium'
import {formatDateTimeForUpdateDate} from '../../../formatters/formatDate'
import NatAuthKeyNoticeApplyRejectionForm from './admin/NatAuthKeyNoticeApplyRejectionForm'
import {
    NatPutResidentNoticeApplyRejection,
    NatPutResidentNoticeApplyRejectionParams,
} from '../roomToResident/repository/NatPutResidentNoticeApplyRejection'
import {NatGetRoomToResidentAuthKeyNoticeData} from '../roomToResident/repository/NatGetRoomToResidentAuthKeyNoticeData'
import NatPrintDialogComponent, {PRINT_TYPE} from '../common/NatPrintDialogComponent'
import {
    NatPutRoomToResidentNoticeIssueDone,
    NatPutRoomToResidentNoticeIssueDoneParams,
} from '../roomToResident/repository/NatPutRoomToResidentNoticeIssueDone'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {NatGetAdminUser} from '../adminUser/repository/NatGetAdminUser'
import NatAdminUserRepo from '../adminUser/repository/NatAdminUserRepo'
import {Location} from 'react-router-dom'
import ReactDOM from 'react-dom'

const LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    seq: number
    roomToResidentRepo: NatRoomToResidentRepo
    condominiumRepo: NatCondominiumRepo
    adminUserRepo: NatAdminUserRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    residentUserAuthKeyNoticeApplyInfo: ResidentUserAuthKeyNoticeApplyInfo
    authKeyNoticeData: NatGetRoomToResidentAuthKeyNoticeData
    rejectionReason: string
    rejectionDialogOpen: boolean
    noticeIssueOpen: boolean
    applicantMailAddressHaveOrNot: string
    isLoadCompleted: boolean
}

class NatAdminResidentAuthKeyNoticeApply extends Component<Props & AdminPagePropsSet, States> {
    applyName: string = '居住者ユーザ申請'
    loginUserRoleId: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.loginUserRoleId = SessionStorageHelper.getStringItemOrNull(LOGIN_USER_ROLE_ID)
        this.state = {
            residentUserAuthKeyNoticeApplyInfo: {
                seq: 0,
                applyCategory: '',
                applyStatus: '',
                roomNumber: '',
                condominiumCd: '',
                ridgeCd: '',
                ridgeName: '',
                roleId: '',
                applicantId: '',
                residentName: '',
                approveUserFamilyName: '',
                approveUserFirstName: '',
                approvalDatetime: '',
                rejectionUserFamilyName: '',
                rejectionUserFirstName: '',
                rejectionDatetime: '',
                rejectionReason: '',
                residentSeq: 0,
                residentStatus: 0,
                roomToResidentVersion: 0,
                noticeApplyVersion: 0,
            },
            authKeyNoticeData: {
                details: null,
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            rejectionReason: '',
            rejectionDialogOpen: false,
            noticeIssueOpen: false,
            applicantMailAddressHaveOrNot: HAVE_OR_NOT.NOT.value,
            isLoadCompleted: false,
        }
        this.handleRejectionReasonChange = this.handleRejectionReasonChange.bind(this)
        this.handleCancelClick = this.handleCancelClick.bind(this)
        this.handleApprovalButtonClick = this.handleApprovalButtonClick.bind(this)
        this.handleApprovalOkClick = this.handleApprovalOkClick.bind(this)
        this.handleRejectionButtonClick = this.handleRejectionButtonClick.bind(this)
        this.handleRejectionCancelClick = this.handleRejectionCancelClick.bind(this)
        this.handleRejectionOkClick = this.handleRejectionOkClick.bind(this)
        this.handleNoticeIssueClick = this.handleNoticeIssueClick.bind(this)
        this.handleNoticeIssueCancelClick = this.handleNoticeIssueCancelClick.bind(this)
        this.handleNoticeIssuePrintClick = this.handleNoticeIssuePrintClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 認証キー通知状発行申請情報取得
            await this.getResidentUserAuthKeyNoticeApply()

            // メールアドレス有無チェック
            const haveMailAddress: HAVE_OR_NOT = await this.mailAddressHaveOrNot()
            this.setState({applicantMailAddressHaveOrNot: haveMailAddress.value})

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getResidentUserAuthKeyNoticeApply(): Promise<void> {
        const {roomToResidentRepo, seq} = this.props

        const residentUserApply: Nullable<NatGetResidentAuthKeyNoticeApplyResponse> =
            await this.props.asyncCallFunction(
                roomToResidentRepo.getResidentUserAuthKeyNoticeApply.bind(
                    roomToResidentRepo,
                    seq,
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
        if (residentUserApply && residentUserApply.details) {
            ReactDOM.flushSync(() => {
                this.setState({residentUserAuthKeyNoticeApplyInfo: residentUserApply.details})
            })
        }
    }

    async mailAddressHaveOrNot(): Promise<HAVE_OR_NOT> {
        const {adminUserRepo} = this.props

        if (this.state.residentUserAuthKeyNoticeApplyInfo.applicantId) {
            const adminUserResponse: Nullable<NatGetAdminUser> = await this.props.asyncCallFunction(
                adminUserRepo.getAdminUser.bind(
                    adminUserRepo, this.state.residentUserAuthKeyNoticeApplyInfo.applicantId,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (adminUserResponse && adminUserResponse.details) {
                if (adminUserResponse.details.roleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value
                    && (adminUserResponse.details.mailAddressPc || adminUserResponse.details.mailAddressMb)) {
                    return HAVE_OR_NOT.HAVE
                }
            }
        }

        // 物件情報取得
        if (this.state.residentUserAuthKeyNoticeApplyInfo.condominiumCd) {
            const condominiumResponse: Nullable<NatGetCondominium> = await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominium.bind(
                    this.props.condominiumRepo, this.state.residentUserAuthKeyNoticeApplyInfo.condominiumCd,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (condominiumResponse && condominiumResponse.details) {
                return condominiumResponse.details.condominiumContactInfo.length < 1 ?
                    HAVE_OR_NOT.NOT : HAVE_OR_NOT.HAVE
            }
        }

        return HAVE_OR_NOT.NOT
    }

    getDisplayFullName(familyName: Nullable<string>,
                       firstName: Nullable<string>): Nullable<string> {
        return familyName && firstName ?
            getStringOrEmptyString(familyName) + ' ' + getStringOrEmptyString(firstName) : null
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    handleCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleApprovalButtonClick(): Promise<void> {
        const message = this.state.applicantMailAddressHaveOrNot === HAVE_OR_NOT.NOT.value
            ? Messages.IRESA0017
            : Messages.IRESA0016

        this.beforeUserAction()
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: message.errorLevel,
                message: message.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleApprovalOkClick,
                    },
                ],
            },
        )
    }

    async handleApprovalOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRoomToResidentNoticeApplyPermitParams = {
                condominiumCd: this.state.residentUserAuthKeyNoticeApplyInfo.condominiumCd,
                ridgeCd: this.state.residentUserAuthKeyNoticeApplyInfo.ridgeCd,
                roomNumber: this.state.residentUserAuthKeyNoticeApplyInfo.roomNumber,
                seq: this.state.residentUserAuthKeyNoticeApplyInfo.residentSeq,
                noticeApplyVersion: this.state.residentUserAuthKeyNoticeApplyInfo.noticeApplyVersion,
                roomToResidentVersion: this.state.residentUserAuthKeyNoticeApplyInfo.roomToResidentVersion,
            }
            const response: Nullable<NatPutRoomToResidentNoticeApplyPermit> = await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.putRoomToResidentNoticeApplyPermit.bind(
                    this.props.roomToResidentRepo, request),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (response && response.requestError === null) {
                await this.getResidentUserAuthKeyNoticeApply()
                await this.props.eventEmitter.showHeadingAreaMessage({
                    title: null,
                    messageLevel: MESSAGE_TYPE.INFORMATION,
                    detail: Messages.IRESA0023.toString(this.applyName),
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleNoticeIssueClick(): Promise<void> {
        try {
            // 通知状内のデータを取得
            const response: Nullable<NatGetRoomToResidentAuthKeyNoticeData> = await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.getAuthKeyNoticeData.bind(this.props.roomToResidentRepo,
                    this.state.residentUserAuthKeyNoticeApplyInfo.condominiumCd,
                    this.state.residentUserAuthKeyNoticeApplyInfo.ridgeCd,
                    this.state.residentUserAuthKeyNoticeApplyInfo.roomNumber,
                    this.state.residentUserAuthKeyNoticeApplyInfo.residentSeq.toString(),
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (response && response.details) {
                this.setState({
                    authKeyNoticeData: response,
                    noticeIssueOpen: true,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    getNoticeIssueDialogComponent(): ReactElement | null {
        if (this.state.authKeyNoticeData && this.state.authKeyNoticeData.details) {
            return (
                <NatPrintDialogComponent
                    open={this.state.noticeIssueOpen}
                    title={'通知状の確認'}
                    errorLevel={Messages.IRESA0015.errorLevel}
                    message={Messages.IRESA0015.toString()}
                    printType={PRINT_TYPE.authKeyNotice}
                    loginUserRoleId={this.loginUserRoleId}
                    isWarn={true}
                    closeDiaLogHandler={this.handleNoticeIssueCancelClick}
                    printExecuteHandler={this.handleNoticeIssuePrintClick}
                    authKeyNoticeParams={{
                        condominiumName: this.state.authKeyNoticeData.details.condominiumName,
                        ridgeName: this.state.authKeyNoticeData.details.ridgeName,
                        roomNumber: this.state.authKeyNoticeData.details.roomNumber,
                        issueDate: this.state.authKeyNoticeData.details.issueDate,
                        authenticationKey: this.state.authKeyNoticeData.details.authenticationKey,
                        firstLoginAccessUrl: this.state.authKeyNoticeData.details.firstLoginAccessUrl,
                    }}
                />
            )
        } else {
            return null
        }
    }

    async handleNoticeIssuePrintClick(): Promise<void> {
        try {
            if (this.state.residentUserAuthKeyNoticeApplyInfo) {
                const request: NatPutRoomToResidentNoticeIssueDoneParams = {
                    condominiumCd: this.state.residentUserAuthKeyNoticeApplyInfo.condominiumCd,
                    ridgeCd: this.state.residentUserAuthKeyNoticeApplyInfo.ridgeCd,
                    roomNumber: this.state.residentUserAuthKeyNoticeApplyInfo.roomNumber,
                    seq: this.state.residentUserAuthKeyNoticeApplyInfo.residentSeq,
                    noticeApplyVersion: this.state.residentUserAuthKeyNoticeApplyInfo.noticeApplyVersion,
                    roomToResidentVersion: this.state.residentUserAuthKeyNoticeApplyInfo.roomToResidentVersion,
                }
                // 通知状発行完了
                const response: Nullable<NatPutRoomToResidentNoticeIssueDone> = await this.props.asyncCallFunction(
                    this.props.roomToResidentRepo.putAuthKeyNoticeIssueDone.bind(
                        this.props.roomToResidentRepo, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                )
                if (response && response.requestError === null) {
                    window.location.reload()
                } else {
                    return
                }
            }
        } finally {
            this.setState({noticeIssueOpen: false})
        }
    }

    handleNoticeIssueCancelClick(): void {
        this.setState({noticeIssueOpen: false})
    }

    handleRejectionReasonChange(value: string): void {
        this.setState({rejectionReason: value})
    }

    handleRejectionButtonClick(): void {
        this.beforeUserAction()
        this.setState({rejectionDialogOpen: true})
    }

    handleRejectionCancelClick(): void {
        this.setState({rejectionReason: '', rejectionDialogOpen: false})
    }

    async handleRejectionOkClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutResidentNoticeApplyRejectionParams = {
                condominiumCd: this.state.residentUserAuthKeyNoticeApplyInfo.condominiumCd,
                ridgeCd: this.state.residentUserAuthKeyNoticeApplyInfo.ridgeCd,
                roomNumber: this.state.residentUserAuthKeyNoticeApplyInfo.roomNumber,
                seq: this.state.residentUserAuthKeyNoticeApplyInfo.residentSeq,
                rejectionReason: this.state.rejectionReason,
                version: this.state.residentUserAuthKeyNoticeApplyInfo.noticeApplyVersion,
            }
            const response: Nullable<NatPutResidentNoticeApplyRejection> = await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.putRoomToResidentNoticeApplyRejection.bind(
                    this.props.roomToResidentRepo, request),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (response && response.requestError === null) {
                this.setState({
                    rejectionReason: '',
                    rejectionDialogOpen: false,
                }, async () => {
                    await this.getResidentUserAuthKeyNoticeApply()
                    await this.props.eventEmitter.showHeadingAreaMessage({
                        title: null,
                        messageLevel: MESSAGE_TYPE.INFORMATION,
                        detail: Messages.IRESA0041.toString(this.applyName),
                    })
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    renderApprovalButton(): ReactNode {
        return (
            <AdminPrimaryButton
                onClick={this.handleApprovalButtonClick}
            >
                承認
            </AdminPrimaryButton>
        )
    }

    renderRejectionButton(): ReactNode {
        return (
            <AdminPrimaryButton
                onClick={this.handleRejectionButtonClick}
            >
                却下
            </AdminPrimaryButton>
        )
    }

    renderNoticeIssueButton(): ReactNode {
        return (
            <AdminPrimaryButton
                disabled={!(this.state.residentUserAuthKeyNoticeApplyInfo.applyStatus === APPLY_STATUS.POSSIBLE.value &&
                    this.state.residentUserAuthKeyNoticeApplyInfo.residentStatus !== null)}
                onClick={this.handleNoticeIssueClick}
            >
                通知状発行
            </AdminPrimaryButton>
        )
    }

    renderPageHeaderArea(): Nullable<ReactNode> {
        const applyStatus: APPLY_STATUS = APPLY_STATUS.codeToEnumConstants(
            this.state.residentUserAuthKeyNoticeApplyInfo.applyStatus,
        )
        return (
            <>
                <PageFotterAreaLeft>
                    <HeaderButtonByApplyStatusAndAuthority
                        applyStatus={applyStatus}
                        displayableApplyStatus={[APPLY_STATUS.APPLYING]}
                        displayableAuthorities={[HKConstants.CMN.AUTH.APPROVAL_RESIDENT_USER]}>
                        <Box mr={'15px'}>
                            {this.renderApprovalButton()}
                        </Box>
                    </HeaderButtonByApplyStatusAndAuthority>
                    <HeaderButtonByApplyStatusAndAuthority
                        applyStatus={applyStatus}
                        displayableApplyStatus={[APPLY_STATUS.APPLYING]}
                        displayableAuthorities={[HKConstants.CMN.AUTH.APPROVAL_RESIDENT_USER]}>
                        <Box mr={'15px'}>
                            {this.renderRejectionButton()}
                        </Box>
                    </HeaderButtonByApplyStatusAndAuthority>
                    <HeaderButtonByApplyStatusAndAuthority
                        applyStatus={applyStatus}
                        displayableApplyStatus={[APPLY_STATUS.POSSIBLE, APPLY_STATUS.DONE]}
                        displayableAuthorities={[HKConstants.CMN.AUTH.APPROVAL_RESIDENT_USER,
                            HKConstants.CMN.AUTH.APPLY_RESIDENT_USER]}>
                        <Box mr={'15px'}>
                            {this.renderNoticeIssueButton()}
                        </Box>
                    </HeaderButtonByApplyStatusAndAuthority>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderApplyInfo(): ReactNode {
        const {residentUserAuthKeyNoticeApplyInfo} = this.state

        const applyCategory: RESIDENT_USER_REGISTRATION_APPLY_CATEGORY =
            RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.codeToEnumConstants(
                residentUserAuthKeyNoticeApplyInfo.applyCategory,
            )

        const applyStatus: APPLY_STATUS = APPLY_STATUS.codeToEnumConstants(
            residentUserAuthKeyNoticeApplyInfo.applyStatus,
        )

        const approveFullName: Nullable<string> = this.getDisplayFullName(
            residentUserAuthKeyNoticeApplyInfo.approveUserFamilyName,
            residentUserAuthKeyNoticeApplyInfo.approveUserFirstName,
        )

        const approvalDatetime: string =
            residentUserAuthKeyNoticeApplyInfo.approvalDatetime ?
                formatDateTimeForUpdateDate(residentUserAuthKeyNoticeApplyInfo.approvalDatetime) : ''

        let rejectionFullName: Nullable<string> = this.getDisplayFullName(
            residentUserAuthKeyNoticeApplyInfo.rejectionUserFamilyName,
            residentUserAuthKeyNoticeApplyInfo.rejectionUserFirstName,
        )

        let rejectionDatetime: string =
            residentUserAuthKeyNoticeApplyInfo.rejectionDatetime ?
                formatDateTimeForUpdateDate(residentUserAuthKeyNoticeApplyInfo.rejectionDatetime) : ''

        if (residentUserAuthKeyNoticeApplyInfo.applyStatus === APPLY_STATUS.REJECTION.value &&
            rejectionFullName === null) {
            rejectionFullName = '-'
            rejectionDatetime = '-'
        }

        return (
            <>
                <Table>
                    <StyledTableCaption>申請情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>申請区分</TableRowName>
                            <TableCell colSpan={4}>
                                {applyCategory.label}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>ステータス</TableRowName>
                            <TableCell colSpan={4}>
                                {applyStatus.label}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>部屋番号</TableRowName>
                            <TableCell colSpan={4}>
                                {residentUserAuthKeyNoticeApplyInfo.ridgeName +
                                    ' ' +
                                    residentUserAuthKeyNoticeApplyInfo.roomNumber}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請者 氏名</TableRowName>
                            <TableCell colSpan={4}>
                                {residentUserAuthKeyNoticeApplyInfo.residentName}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>承認者</TableRowName>
                            <TableCell colSpan={2}>
                                {approveFullName}
                            </TableCell>
                            <TableRowName>承認日時</TableRowName>
                            <TableCell colSpan={2}>
                                {approvalDatetime}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>却下者</TableRowName>
                            <TableCell colSpan={2}>
                                {rejectionFullName}
                            </TableCell>
                            <TableRowName>却下日時</TableRowName>
                            <TableCell colSpan={2}>
                                {rejectionDatetime}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>却下理由</TableRowName>
                            <TableCell colSpan={4}>
                                {residentUserAuthKeyNoticeApplyInfo.rejectionReason}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/residentUser/applyList`,
                        )}
                    >
                        居住者ユーザ申請一覧へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted
        ) {
            return null
        }
        const rejectionForm = (<NatAuthKeyNoticeApplyRejectionForm
            rejectionReason={this.state.rejectionReason}
            eventEmitter={this.props.eventEmitter}
            onChange={this.handleRejectionReasonChange}
        />)

        const message = this.state.applicantMailAddressHaveOrNot === HAVE_OR_NOT.NOT.value
            ? Messages.IRESA0040
            : Messages.IRESA0039

        return (
            <>
                <NatAdminCommonDialogComponent
                    params={{
                        title: '確認',
                        errorLevel: message.errorLevel,
                        message: message.toString(),
                        buttonProps: [
                            {
                                isDefault: false,
                                buttonLabel: 'キャンセル',
                                buttonHandler: this.handleRejectionCancelClick,
                                buttonDisabled: false,
                            },
                            {
                                isDefault: false,
                                buttonLabel: 'OK',
                                buttonHandler: this.handleRejectionOkClick,
                                buttonDisabled: !this.state.rejectionReason,
                            },
                        ],
                    }}
                    inputAreaComponent={rejectionForm}
                    open={this.state.rejectionDialogOpen}/>
                {this.getNoticeIssueDialogComponent()}
                <Box mb={'15px'}>
                    <PageFooterArea>
                        {this.renderPageHeaderArea()}
                    </PageFooterArea>
                </Box>
                <PageMainArea>
                    {this.renderApplyInfo()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

const HeaderButtonByApplyStatusAndAuthority: React.FC<{
    applyStatus: APPLY_STATUS,
    displayableApplyStatus: APPLY_STATUS[],
    displayableAuthorities: string[],
    children: ReactNode
}> = props => {
    let authorityCheck: boolean = false

    let ownAuthority: string = ''
    if (judgeAuthorityCheck(HKConstants.CMN.AUTH.APPLY_RESIDENT_USER)) {
        ownAuthority = HKConstants.CMN.AUTH.APPLY_RESIDENT_USER
    }
    if (judgeAuthorityCheck(HKConstants.CMN.AUTH.APPROVAL_RESIDENT_USER)) {
        // 申請権限と承認権限を保持している場合、承認権限として後続処理を実施
        ownAuthority = HKConstants.CMN.AUTH.APPROVAL_RESIDENT_USER
    }

    for (const displayableAuthority of props.displayableAuthorities) {
        authorityCheck = ownAuthority === displayableAuthority
        if (authorityCheck) {
            break
        }
    }
    if (authorityCheck && props.displayableApplyStatus.includes(props.applyStatus)) {
        return (<>{props.children}</>)
    }
    return (<></>)
}

export default createAdminPage(NatAdminResidentAuthKeyNoticeApply)
